import React, { Suspense } from "react";
import { createRoot } from "@wss/react";
import { withPreloadedJSON } from "@wss/hypernova";
import { initSentry } from "@wss/error-tracking/sentry";
import { Provider } from "react-redux";
import { ErrorBoundary, logErrorBoundaryToSentry, PageFallback } from "@wss/error-tracking/error-boundary";
import { CustomizableProductsPageProps } from ".";
import App from "~/App";
import Store from "~/common/Store";
import useIsMounted from "~/common/useIsMounted";
const CustomizableProductsPage = React.lazy(() => import("./index"));
const Header = React.lazy(() => import("~/common/Header/index.client").then(result => ({
  default: result.Header
})));
const Footer = React.lazy(() => import("~/common/Footer/index.client").then(result => ({
  default: result.Footer
})));

// we may not want this, considering we are loading a series of MFEs here
module.hot?.accept();
initSentry("Customizable Products Page");
const WrappedCustomizableProductsPageWithData = ({
  isTrs,
  ...rest
}: CustomizableProductsPageProps) => {
  const fullProps = {
    isTrs,
    ...rest
  };
  const mounted = useIsMounted();
  return <>
      {!isTrs && <Suspense>
          <Header />
        </Suspense>}
      <ErrorBoundary fallback={<PageFallback />} onError={logErrorBoundaryToSentry} data-sentry-element="ErrorBoundary" data-sentry-source-file="index.client.tsx">
        <Provider store={Store} data-sentry-element="Provider" data-sentry-source-file="index.client.tsx">
          {mounted && <Suspense>
              <CustomizableProductsPage {...fullProps} />
            </Suspense>}
        </Provider>
      </ErrorBoundary>
      {!isTrs && <Suspense>
          <Footer />
        </Suspense>}
    </>;
};

// just to cover this logic with tests
export default WrappedCustomizableProductsPageWithData;
const CustomizableProductsPageWithData = withPreloadedJSON(WrappedCustomizableProductsPageWithData, "CustomizableProductsPage");
const root = createRoot(document.getElementById("root"));
root.render(<App>
    <CustomizableProductsPageWithData />
  </App>);